var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 600,
    height: 600,
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tag",
    transform: "matrix(1.06183,0,0,1.06183,-2.3451,14.0051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.989,142.394L123,300L252.69,429.69L405.487,276.892L270.989,142.394Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999982,-0.00608126,0.00608126,0.999982,-2.26863,2.0646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.487,276.892L405.487,142.394L272.244,142.394L405.487,276.892Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.809035,-0.168755,0.204193,0.978931,35.4843,61.5157)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 140.667,
    width: 17,
    height: 23.333,
    style: {
      fill: "rgb(45,154,249)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10882,0,0,1.11875,-46.3551,35.6536)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "227.91px",
    y: "278.021px",
    style: {
      fontFamily: "'HoboStd', 'Hobo Std', sans-serif",
      fontWeight: 500,
      fontSize: 144,
      fill: "rgb(45,154,249)"
    }
  }, "%")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29808,0,0,1.20588,-123.443,-41.7647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 181,
    r: 17,
    style: {
      fill: "rgb(45,154,249)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.812324,0,0,0.926842,66.735,7.97383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,176.5C364,176.5 337.741,108.301 378,109C418.259,109.699 477.621,122.698 466,167L461,169L464,164L465,156C465,156 465.127,114.347 378,113C378,113 346.357,104.97 368,176.5C368,176.5 366.981,178.39 364,176.5Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.32px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleIcon);
export default __webpack_public_path__ + "static/media/sale-icon.aad15405a8d3e3f6a51d368b99acec6e.svg";
export { ForwardRef as ReactComponent };